import styled from "styled-components";

export const ButtonWrap = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
